<template>
  <div
    class="fixed bottom-0 left-0 w-full p-2 z-50 bg-white border border-t-gray-45s0"
  >
    <MobileMenu />
  </div>
</template>

<script setup lang="ts">
import MobileMenu from "@/components/Mobile/Menu.vue";
</script>

<style scoped></style>
